export const resumePauseTitle = "Resume All Cadences";
export const resumePauseBody =
  "Are you ready to come back? Your cadences will resume where you left off, and we'll reactivate your tasks starting with those due today.";
export const resumePauseAction = "Resume";
export const cancelPauseTitle = "Cancel Pause";
export const cancelPauseBody = "Are you sure you want to cancel this pause?";
export const cancelPauseAction = "Cancel Pause";
export const cadenceStartMsgDefault = "This is your first day out of office.";
export const cadenceStartMsgImt = "All your cadences will pause immediately.";
export const cadencesPaused = "Your cadences are currently paused.";
export const cadenceEndMsgDefault = "This is the date you plan to resume your work.";
